module.exports = __webpack_public_path__ + "img/pathCheckBold.c2a31bd0.svg";